import { render, staticRenderFns } from "./MyBookingsCatalog.vue?vue&type=template&id=c1df16b2"
import script from "./MyBookingsCatalog.vue?vue&type=script&lang=js"
export * from "./MyBookingsCatalog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports